// 对账
import RECONCILIATION from './module/reconciliation';
// 登录注册
import LOGIN from './module/login';
// 应用
import APPLY from './module/apply';
// 平台设置
import MCHCHAN from './module/mchchan';
// 交易中心
import TRADING from './module/trading';
// 商户管理
// import MERCHANTS from './module/merchants';

export default {
  RECONCILIATION,
  LOGIN,
  APPLY,
  MCHCHAN,
  TRADING,
  // MERCHANTS
};